import {
  PATIENT_FIELD_RETRIEVED,
  PRESCRIPTION_FIELD_RETRIEVED,
  FREE_SHIPPING_SETTINGS_RECEIVED,
  SCHOOL_RETRIEVED,
  PICKUP_ADDRESS_RECEIVED,
  DATE_FORMAT_APPLIED,
  COMMISSION_SETTING_INFO_RECEIVED,
  FAQ_RETRIEVED,
  REMEMBER_SETTINGS_RECEIVED,
} from "../constants/types/settingsType";

const initialState = {
  patientFormFields: [],
  prescriptionFormFields: [],
  freeShippingSettings: [],
  schools: [],
  dateFormat: "",
  pickupAddress: {},
  showCommission: "0",
  faqs: [],
  rememberSettings: [],
};

export const settingsReducers = (state = initialState, action) => {
  switch (action.type) {
    case PATIENT_FIELD_RETRIEVED:
      return {
        ...state,
        patientFormFields: action.payload,
      };
    case PRESCRIPTION_FIELD_RETRIEVED:
      return {
        ...state,
        prescriptionFormFields: action.payload,
      };
    case FREE_SHIPPING_SETTINGS_RECEIVED:
      return {
        ...state,
        freeShippingSettings: action.payload,
      };
    case SCHOOL_RETRIEVED:
      return {
        ...state,
        schools: action.payload,
      };
    case DATE_FORMAT_APPLIED:
      return {
        ...state,
        dateFormat: action.payload,
      };
    case REMEMBER_SETTINGS_RECEIVED:
      return {
        ...state,
        rememberSettings: action.payload,
      };
    case COMMISSION_SETTING_INFO_RECEIVED:
      return {
        ...state,
        showCommission: action.payload,
      };
    case PICKUP_ADDRESS_RECEIVED:
      return {
        ...state,
        pickupAddress: action.payload,
      };
    case FAQ_RETRIEVED:
      return {
        ...state,
        faqs: action.payload,
      };
    default:
      return state;
  }
};
